<template>
  <v-container class="fill-height"
               fluid>
    <v-row align="center"
           justify="center">
      <v-col cols="12"
             sm="8"
             md="6">

        <v-form @submit.prevent="submit">
          <v-card elevation="12">
            <v-card-title>
              Forgot your password?
            </v-card-title>
            <v-card-text>
              <p>
                To reset your password, enter your email address.
              </p>
              <v-text-field v-model="form.email"
                            type="email"
                            label="Email"
                            placeholder="Your email"
                            required
                            :rules="[rules.required]"
                            :error-messages="form.errors.get('email')">
              </v-text-field>

            </v-card-text>
            <v-card-actions class="d-flex flex-column">
              <v-btn color="primary"
                     :disabled="form.busy"
                     block
                     type="submit"
                     class="mb-2">
                Get a new password
              </v-btn>

              <v-btn :to="{name: 'login'}"
                     :disabled="form.busy"
                     block
                     text
                     class="ml-0">
                Back to Log in
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>

        <v-alert type="success"
                 class="mt-3"
                 v-if="message">
          {{ message }}
        </v-alert>

      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import {Form} from 'vform';
import formValidation from '../../../plugins/formValidation';

export default {
  mixins: [formValidation],
  data() {
    return {
      form: new Form({
        email: '',
      }),
      message: null,
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() { // MLD-4953
      axios.get('/spark/token')
        .then()
        .catch(() => {
        });
    },
    submit() {
      this.message = null;
      this.form.post(`/password/email`)
        .then(({data}) => {
          //console.log(data);
          this.message = data.message;
        })
        .catch(err => {
          if (err.response && err.response.data) {
            this.message = err.response.data.message;
          } else {
            this.message = 'If you have a Mobile Locker account, we sent you an email with a link to finish resetting your password. Contact support@mobilelocker.com if you need assistance.';
          }
        })
    }
  }
}
</script>
